/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface ApiCustomerCustomerIdCollectedServiceDateGet$Plain$Params {
  customerId: number;
  collectedServiceDate: string;
}

export function apiCustomerCustomerIdCollectedServiceDateGet$Plain(http: HttpClient, rootUrl: string, params: ApiCustomerCustomerIdCollectedServiceDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
  const rb = new RequestBuilder(rootUrl, apiCustomerCustomerIdCollectedServiceDateGet$Plain.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('collectedServiceDate', params.collectedServiceDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDto>;
    })
  );
}

apiCustomerCustomerIdCollectedServiceDateGet$Plain.PATH = '/api/Customer/{customerId}/{collectedServiceDate}';
